









































import Vue from 'vue';
import Snake from '@/components/Snake.vue';

export default Vue.extend({
  name: 'Footer',
  components: {
    Snake,
  },
});
